"use client";

import { ArrowLeft } from "lucide-react";
import Link from "next/link";
import type { ReactNode } from "react";
import { getLegalContent } from "@/content/legal";
import { useLocale } from "@/lib/i18n/provider";
import { localizePath } from "@/lib/i18n/routing";

type Props = {
  eyebrow: string;
  title: string;
  lastUpdated: string;
  children: ReactNode;
};

export function LegalArticle({ eyebrow, title, lastUpdated, children }: Props) {
  const { locale } = useLocale();
  const legal = getLegalContent(locale);

  return (
    <article className="mx-auto w-full max-w-4xl px-5 pb-20 pt-28 md:px-7 md:pb-24 md:pt-36">
      <Link
        href={localizePath("/", locale)}
        className="inline-flex items-center gap-2 text-sm text-[var(--color-text-secondary)] transition-colors hover:text-[var(--color-text-primary)]"
      >
        <ArrowLeft size={14} />
        {legal.ui.backToHomeLabel}
      </Link>

      <div className="mt-8">
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[var(--color-text-muted)]">
          {eyebrow}
        </p>
        <h1 className="mt-4 text-[clamp(2rem,4.8vw,3.2rem)] font-bold leading-[1.05] tracking-[-0.03em] text-[var(--color-text-primary)]">
          {title}
        </h1>
        <p className="mt-4 text-[12px] uppercase tracking-[0.18em] text-[var(--color-text-muted)]">
          {legal.ui.lastUpdatedPrefix} {lastUpdated}
        </p>
      </div>

      <div className="legal-prose mt-14">{children}</div>
    </article>
  );
}

export default LegalArticle;
